
export const state = {
    user: null,
    loggedIn: false,
    $storage: {
        setUniversal: (property, payload)=> {
            const isObject = typeof payload === 'object' && payload !== null;
            const stringifiedData = isObject ? JSON.stringify(payload) : payload;
            localStorage.setItem(property, stringifiedData);
        },
        getUniversal: (property)=> {
            const data = localStorage.getItem(property);
            try {
                return JSON.parse(data);
            } catch (e) {
                return data;
            }
        },
        removeUniversal: (property)=> {
            localStorage.removeItem(property);
        },
    },
    clearUser: () => {
        localStorage.removeItem('userToken');
        localStorage.removeItem('user');
    }
};

export const mutations = {
    SET_USER(state, payload){
        state.$storage.setUniversal('user', payload);
        state.user = payload;
        state.loggedIn = true;
    },
    SET_LOGGED_IN(state){
        state.loggedIn = true;
    },
    SET_LOGGED_OUT(state){
        state.loggedIn = false;
    },
};

